<template>
  <div id="footer" class="navbar navbar-expand-lg justify-content-center bg-dark">
    <div class="m-4">
      <!-- footer con el nombre de la empresa -->
      <a
        @click="toTheTop"
        class="text-white"
        :href="$router.resolve({name: 'Politicas'}).href"
      >Política de privacidad</a>
      <br />
      <strong>Copyright 2020 © APIS Systems Developer C.A. Rif: J-41315957-0</strong>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    toTheTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>
<style scoped>
#footer {
  color: white;
}
</style>
